import { isDefined } from "@omni/utils/helper.utils";

import { CookieList } from "./enums";

function getCookie(name: CookieList) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
}

function setCookie(name: CookieList, value: string, days?: number) {
    let expires = "";

    if (isDefined(days)) {
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

        expires = `;expires=${d.toUTCString()}`;
    }

    const cookie = `${name}=${value};path=/${expires};domain=.${LIB_NAME}.be`;

    document.cookie = cookie;
}

function deleteCookie(name: CookieList): void {
    setCookie(name, "", -1);
}

export { deleteCookie, getCookie, setCookie };
